import React from "react"
import { queryOptions, type SkipToken, skipToken } from "@tanstack/react-query"
import { getDeviceDate } from "@myvp/shared/src/clock/get-device-date"

export interface ClockApi {
  readonly id: unknown
  readonly readData: () => Date | SkipToken | undefined
  readonly fetchData: () => Promise<Date | SkipToken>
}

export const defaultClockApi = (): ClockApi => ({
  id: "real",
  readData: () => skipToken,
  fetchData: async () => skipToken,
})

export const ClockApiProvider = React.createContext(defaultClockApi())

export const useClockApi = (): ClockApi => {
  return React.useContext(ClockApiProvider)
}

export const clockQueryOptions = (api: ClockApi) => {
  return queryOptions({
    queryKey: ["clock", api.id],
    queryFn: async () => {
      return api.fetchData()
    },
  })
}

export const resolveClockData = (
  data: Date | SkipToken | undefined,
  fallback: ((data: SkipToken | undefined) => Date) | undefined
): Date => {
  if (data instanceof Date) {
    return data
  } else if (fallback) {
    return fallback(data)
  } else {
    return getDeviceDate()
  }
}
